module.exports = __webpack_public_path__ + "static/media/Pizza Delivery Man.6d9c30f2.jpg";